import { render } from "./RkeeperIntegration.vue?vue&type=template&id=815bf244"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/RkeeperIntegration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "815bf244"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('815bf244', __exports__)) {
    api.reload('815bf244', __exports__)
  }
  
  module.hot.accept("./RkeeperIntegration.vue?vue&type=template&id=815bf244", () => {
    api.rerender('815bf244', render)
  })

}


export default __exports__